import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const NewsPage = () => {
  return (
    <UnderConstruction 
      title="News & Updates"
      description="Get the latest updates on CNESS developments, new certifications, partner announcements, and industry insights."
      expectedLaunch="Coming Soon"
    />
  );
};

export default NewsPage;